export default{
	data(){
		return{
			// 加载
			loading:false,
			// 在学课程列表
			inschoolclass:[],
			// 每页显示条数
			pageSize: 5,
			// 当前页
			currentPage: 1,
			// 总页数
			total: 0,
		}
	},
	methods:{
		getData(){
			this.$post('orders/search_pay_all',{
				token: this.$store.state.id,
				offset: (this.currentPage - 1) * this.pageSize,
				length: this.pageSize,
				is_read: '是'
			}).then(res=>{
				this.inschoolclass = res.data.result.result;
				this.total = res.data.result.total
				this.courseConfig(this.inschoolclass);
			})
        },
		
		// ----------------------------------------------------------------------
		// 检查课程
		courseConfig(result) {
			let res = result
			//遍历计算进度
			res.map((item, index) => {
				let category_progress = 0
				let allProgress = 0
				item.purchased.map((item1, index1) => {
					allProgress += item1.progress
				})
				// console.log(item)
				category_progress = allProgress / item.purchased.length
				// 课程包进度比实际课程包进度小的就发请求去纠正
				// console.log('item.category_progress',item.category_progress)
				// console.log('category_progress.toFixed(4)',category_progress.toFixed(4))
				if (item.category_progress != 1 && category_progress.toFixed(4) == 1) {
					this.$post('category_order/update', {
						id: item.category_order_id,
						category_progress: 1
					}).then(res=>{
						this.screen1() //获取全部课程数据
					})
				}
			})
		},
		// ----------------------------------------------------------------------
        
        // 跳转到课后习题页面
		toExam(category_order_id, resource_id, category_id, category_name) {
			this.$router.push({
				path: './classexam',
				query: {
					id: resource_id,
                    categoryOrderId: category_order_id,
                    categoryId: category_id,
                    categoryName: category_name,
				}
			})
        },
		
		// 每页的显示条数改变时调用
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.getData()
		},
		
		// 当前页改变时调用
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.getData()
		},
		
		//跳转课程详情
		classDetails: function(id, is_project, purchased_id, categoryOrderId) {
		    let address = this.$router.resolve({
		        path: '/classstudy',
		        query: {
		            id: id,
		            purchased_id: purchased_id,
		            categoryOrderId: categoryOrderId
		        }
		    });
		    window.open(address.href, "_blank")
			// this.$toClass(id, is_project, purchased_id);
		},
	},
	created(){
		this.getData();
	}
}